import React, {useState, useEffect} from 'react';
import './Pagination.css';

export function Pagination({total, limit, page, onChange}) {
  const [pages, setPages] = useState(null);

  useEffect(() => {
    function generate(total, limit, page) {
      const pages = {
        list: [],
        last: 0
      };
      if (total === 0) {
        return pages;
      }
      let n = Math.ceil(total / limit);
      let f = 1;
      let l = n;
      if (n > 8) {
        f = Math.max(1, page - 3);
        l = Math.min(f + 6, n);
      }
      if (f > 1) {
        pages.list.push(1);
      }
      if (f > 2) {
        pages.list.push(0);
      }
      for (let i = f; i <= l; i++) {
        pages.list.push(i);
      }
      if (l < n - 1) {
        pages.list.push(0);
      }
      if (l < n) {
        pages.list.push(n);
      }
      pages.last = n;
      return pages;
    };

    setPages(generate(total, limit, page));
  }, [total, page, limit]);

  if (pages === null || total === 0) {
    return null;
  }

  return <div className="pagination">
    <ul className="pagination__list">
      <li className="pagination__item">
        <span className={"pagination__arrow pagination__arrow--double-left" + (page === 1 ? " pagination__arrow--disabled" : "")} onClick={() => onChange(1)}></span>
      </li>
      <li className="pagination__item">
        <span className={"pagination__arrow pagination__arrow--left" + (page === 1 ? " pagination__arrow--disabled" : "")} onClick={() => onChange(page - 1)}></span>
      </li>
      {
        pages.list && pages.list.length > 0 && pages.list.map((i, k) => {
          return <li key={k} className={"pagination__item" + (i === page ? " pagination__item--active" : "")}>
            {i === 0 && <span className="pagination__link pagination__link--disabled">...</span>}
            {i !== 0 && <span className={"pagination__link" + (i === page ? " pagination__item--disabled" : "")} onClick={() => onChange(i)}>{i}</span>}
          </li>
        })
      }
      <li className="pagination__item">
        <span className={"pagination__arrow pagination__arrow--right" + (page >= pages.last ? " pagination__arrow--disabled" : "")} onClick={() => onChange(page + 1)}></span>
      </li>
      <li className="pagination__item">
        <span className={"pagination__arrow pagination__arrow--double-right" + (page >= pages.last ? " pagination__arrow--disabled" : "")} onClick={() => onChange(pages.last)}></span>
      </li>
    </ul>
  </div>;
}
